package com.clany.backoffice.domain.usecase

import com.clany.backoffice.domain.repository.AccountRepository
import com.clany.backoffice.model.AccountResponse

import dev.zacsweers.metro.Inject

@Inject
class GetAccountsUseCase(
    private val accountRepository: AccountRepository
) {
    suspend operator fun invoke(page: Int, pageSize: Int, query: String? = null): Result<List<AccountResponse>> {
        return accountRepository.getAccounts(page, pageSize, query)
    }
}
